const SERVER = 'https://blossom.psbt.me';
const TESTNUT = 'https://testnut.cashu.exchange';
const ACCEPTED_MINTS = [
  'https://testnut.cashu.exchange',
  'https://minibits.cashu.exchange',
  'https://8ballmn.com',
];

export function createUserStore() {
  let pubkey = $state<string | null>(null);
  let loggedIn = $derived(pubkey !== null);

  return {
    get pubkey() { return pubkey; },
    get loggedIn() { return loggedIn; },
    set(pubkeyHex: string | null) { pubkey = pubkeyHex; },
  };
}

export const user = createUserStore();
export { SERVER, TESTNUT, ACCEPTED_MINTS };
